module.exports = "/static/31a37ae5ec62d6501a8a6c7177acccb4.svg";